export class RandomUtils {

  public static generateRandomString(length: number): string {
    let text       = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }

  public static generateRandomInt(length: number): string {
    let text       = '';
    const possibleWithout0 = '123456789';
    const possible = '0' + possibleWithout0;

    for (let i = 0; i < length; i++) {
      let p = possible;
      if (i === 0) {
        p = possibleWithout0;
      }
      text += p.charAt(Math.floor(Math.random() * p.length));
    }

    return text;
  }
}
